var TimetablePeriod;
(function (TimetablePeriod) {
    TimetablePeriod["Half"] = "half";
    TimetablePeriod["Full"] = "full";
})(TimetablePeriod || (TimetablePeriod = {}));
class TimetableManager {
    init() {
        $('.js-Timetable').each((index, element) => {
            const table = this._createInstance($(element));
            this._setActivityPositions(table);
            this._setScrollHelper(table);
            $(window).resize(() => this._setScrollHelper(table));
        });
    }
    _setScrollHelper(table) {
        const tableId = table.node.attr('data-id');
        const image = $('.js-Timetable-Scroller').filter((index, element) => element.getAttribute('data-id') === tableId);
        const tableWidth = table.node.width();
        const containerWidth = table.node.parent().width();
        if (tableWidth > containerWidth) {
            if (image.css('display') === 'block')
                return;
            image.css('display', 'block');
        }
        else {
            if (image.css('display') === 'none')
                return;
            image.css('display', 'none');
        }
    }
    _setActivityPositions(table) {
        table.activities.forEach(activity => {
            const { x, width } = TimetableManager._calculateActivityPosition(table, activity);
            if (width < 110) {
                activity.node.addClass('Timetable__Activities-Item--Compact');
            }
            activity.node.css({
                width: `${width}px`,
                transform: `translateX(${x}px)`
            });
        });
    }
    static _convertTimeToDecimal(value) {
        const time = value.split('.');
        const minutes = parseFloat(time.pop()) / 60;
        const hours = time.pop();
        return parseInt(hours) + minutes;
    }
    static _calculateActivityPosition(table, activity) {
        const activityStartTime = TimetableManager._convertTimeToDecimal(activity.startTime);
        const activityEndTime = TimetableManager._convertTimeToDecimal(activity.endTime);
        const tableStartTime = TimetableManager._convertTimeToDecimal(table.startTime);
        const differenceTableActivityStartTime = activityStartTime - tableStartTime;
        const differenceActivityTime = activityEndTime - activityStartTime;
        const period = table.period === TimetablePeriod.Half ? 2 : 1;
        const x = table.cellWidth * differenceTableActivityStartTime * period;
        const width = table.cellWidth * differenceActivityTime * period;
        return { x, width };
    }
    _activityClickHandler($link) {
        $link.on('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const $overlay = $link.parent().find('.js-Overlay-Agenda');
            if ($overlay.length === 0)
                console.error('Missing overlay node for activity item', event.target);
            const { overlayManager } = (await import('./overlay'));
            overlayManager.open($overlay);
        });
    }
    _createActivity(table) {
        const activities = [];
        table.find('.js-Timetable-Activity')
            .each((index, activity) => {
            const $activity = $(activity);
            const $link = $activity.find('.js-Timetable__Activity');
            if ($link.length)
                this._activityClickHandler($link);
            const endTime = $activity.attr('data-end');
            activities.push({
                node: $activity,
                startTime: $activity.attr('data-start'),
                endTime: endTime === '00.00' ? '24.00' : endTime
            });
        });
        return activities;
    }
    _createInstance(element) {
        const instance = {
            node: element,
            cellWidth: element.find('.js-Timeline-Heading').first().outerWidth(),
            period: element.attr('data-period'),
            startTime: element.attr('data-start'),
            activities: this._createActivity(element)
        };
        if (!(Object.values(TimetablePeriod).includes(instance.period)))
            throw new Error(`Period '${instance.period}' is invalid. It only accepts the following input: 'half', 'full'`);
        if (!instance.startTime)
            throw new Error('Start time has not been provided for the timetable.');
        return instance;
    }
}
const timetableManager = new TimetableManager();
export { timetableManager };
